<span
  style="cursor: pointer"
  (dblclick)="onDoubleClick()"
  [pTooltip]="tooltipText"
  tooltipPosition="top">
  {{ alternarIdOrigem }}
</span>
